import { AccountApi, ConfigurationApi } from '../api';

import { BASEPATH } from './constants';

export const accountApi = new AccountApi({ basePath: BASEPATH });
export const configurationApi = new ConfigurationApi({ basePath: BASEPATH });
